import React from 'react';
import { ExternalReview } from '../../../types';

interface ReviewDetailsModalProps {
  review: ExternalReview | null;
  isOpen: boolean;
  onClose: () => void;
}

const ReviewDetailsModal: React.FC<ReviewDetailsModalProps> = ({
  review,
  isOpen,
  onClose,
}) => {
  if (!isOpen || !review) return null;

  return (
    <div className="!mt-0 fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4" style={{ zIndex: 9999 }}>
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-bold text-gray-900">Review Feedback</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="space-y-4 text-sm">
          <div>
            <p className="text-gray-600 mb-1">Reviewer</p>
            <p className="font-medium text-gray-900">
              {review.reviewerName || review.reviewerEmail}
            </p>
          </div>

          {review.rating && (
            <div>
              <p className="text-gray-600 mb-1">Rating</p>
              <div className="flex items-center gap-2">
                <span className="font-medium">{review.rating}/5</span>
              </div>
            </div>
          )}

          {review.strengths && (
            <div>
              <p className="text-gray-600 mb-2">Strengths</p>
              <div className="bg-green-50 border border-green-200 rounded p-3">
                <p className="text-gray-800">{review.strengths}</p>
              </div>
            </div>
          )}

          {review.improvements && (
            <div>
              <p className="text-gray-600 mb-2">Areas for Improvement</p>
              <div className="bg-yellow-50 border border-yellow-200 rounded p-3">
                <p className="text-gray-800">{review.improvements}</p>
              </div>
            </div>
          )}

          {review.feedback && (
            <div>
              <p className="text-gray-600 mb-2">Additional Feedback</p>
              <div className="bg-blue-50 border border-blue-200 rounded p-3">
                <p className="text-gray-800">{review.feedback}</p>
              </div>
            </div>
          )}
        </div>

        <div className="mt-6">
          <button
            onClick={onClose}
            className="w-full px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReviewDetailsModal;
